// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__W6pel","invert":"Logo_invert__rWsSa"};